const initialState = {
    reportsByRecons: [],
    reportFieldMappings: {
        mappedDataDictionary: [],
        unMappedDataDictionary: [],
        reconFieldMappings: [],
    },
    reportReconFieldMaps: [],
    reportReconFieldExpressions: [],
    clonedMappedDict: [],
    reconFieldColumnNames: [],
    reportFieldSettings: {},
    reportDataFromWorkflow: {},
    reportCustomQueryResults: []
};
export default initialState;
